import { render, staticRenderFns } from "./PwaInstallerBtn.vue?vue&type=template&id=b36367ee&scoped=true&"
import script from "./PwaInstallerBtn.vue?vue&type=script&lang=js&"
export * from "./PwaInstallerBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36367ee",
  null
  
)

export default component.exports